import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Padding } from '@nib/layout';
import { Bold } from '@nib-components/copy';
import Item from '../Item';
const SuggestedList = _ref => {
  let {
    suggestions,
    getItemProps,
    suggestionsTitle,
    highlightedIndex
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Padding, {
      top: 5,
      horizontal: 3,
      bottom: 4,
      children: /*#__PURE__*/_jsx(Bold, {
        children: suggestionsTitle ? suggestionsTitle : 'Suggested'
      })
    }), suggestions.map((suggestion, index) => /*#__PURE__*/_jsx(Item, {
      ...getItemProps({
        item: suggestion,
        index,
        isActive: highlightedIndex === index
      }),
      children: suggestion.text
    }, `suggestion-${suggestion.text}-${index}`))]
  });
};
SuggestedList.propTypes = {
  suggestionsTitle: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string
  })),
  getItemProps: PropTypes.func,
  highlightedIndex: PropTypes.number
};
export default SuggestedList;